import { useState, useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { sdk } from "@farcaster/miniapp-sdk";
import Header from "./components/Header";
import PreclaimView from "./pages/PreclaimView";
import MintView from "./pages/MintView";
import StoryView from "./pages/Story";
import Intro from "./pages/Intro";
import Mystery from "./pages/MysteryBoxView";
import "./App.css";

import { Mode } from "./enum";
import { WHITELIST_END_TIME } from "./constants/whitelist";
const { Preclaim, Story, Mint, Box } = Mode;

export default function App() {
  const [miniApp, setMiniApp] = useState(false);
  const [mode, setMode] = useState(Mint);
  const [isWhitelistOver, setIsWhitelistOver] = useState(false);

  useEffect(() => {
    const end = new Date(WHITELIST_END_TIME).getTime();
    const update = () => {
      const now = Date.now();
      setIsWhitelistOver(now >= end);
    };
    update();
    const t = setInterval(update, 1000);
    return () => clearInterval(t);
  }, []);

  const onModeChange = (newMode: Mode) => {
    setMode(newMode);
  };

  useEffect(() => {
    const initializeApp = async () => {
      try {
        if (import.meta.env.PROD) {
          const miniApp = await sdk.isInMiniApp();
          setMiniApp(miniApp);
          if (!miniApp) return;

          await sdk.actions.ready();
          await sdk.actions.addMiniApp();
        } else {
          setMiniApp(true);
        }
      } catch (err) {
        console.error(
          "App initialization failed or user eject add miniapp:",
          err
        );
      }
    };
    initializeApp();
  }, []);

  if (!miniApp) {
    return (
      <div className="app">
        <Intro />
      </div>
    );
  }

  const renderView = () => {
    switch (mode) {
      case Preclaim:
        return <PreclaimView isWhitelistOver={isWhitelistOver} />;
      case Mint:
        return <MintView />;
      case Story:
        return <StoryView />;
      case Box:
        return <Mystery />;
      default:
        return null;
    }
  };

  return (
    <div className="app">
      <Header
        mode={mode}
        onModeChange={onModeChange}
        isWhitelistOver={isWhitelistOver}
      />
      <Toaster position="top-center" />
      {renderView()}
    </div>
  );
}
